<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="modalExemplo" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" >{{produto.categoria?produto.categoria.nome:''}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <section class="title" v-if="produto.imagem_url">
                        <img :src="produto.imagem_url" :alt="produto.nome"  width="250" >

                    </section>

                    <div class="card my-3 px-3 py-2 d-flex flex-row header-card">
                        <div style="max-width: 300px;">
                            <h3>{{produto.nome}}</h3>
                            <p>{{produto.descricao}}</p>
                        </div>
                        <div class="ml-auto">
                            <div v-if="!isEmpty" class="d-flex flex-column" style="width:110px">
                                <span v-if="produto.promocao" class="badge badge-pill badge-danger align-self-center mb-2">Em Promoção</span>
                                <del v-if="produto.promocao" class="align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</del>
                                <h4 v-if="produto.promocao" class="preco align-self-center mb-2">R$ {{formatarMoeda(produto.promocao.valor)}}</h4>
                                <h4 v-else class="preco align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['produto'],

        methods: {
            formatarMoeda(valor){
              return valor.replace(".",",")
            },

        }

    }
</script>

<style lang="scss" scoped>



.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.card textarea{
    width: 100%;
    height: 100px;
    padding: 5px;
}

.title{
    text-align: center;
}

.title img {
    margin-left: 20px;
    padding: 4px;
    border: 1px solid #9c9c9c;
    border-radius: 2px;
    object-fit: cover;
    box-shadow: 2px 2px 4px 0px #a7a7a7;
}

.qt{
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.20);
    font-size: 1.2rem;
    width: 35px;
    height: 30px;
    text-align: center;
}

.opcionalNome{
    font-size: 1.1rem;
}

.opcionalValor{
    font-size: 0.8rem;
}

.opcionalQt{
    display: inline-block;
    /* border: 1px solid rgba(0, 0, 0, 0.20); */
    font-size: 1.1rem;
    min-width: 15px;
    height: 25px;
    text-align: center;
}

.opcionalBtn{
    padding: 5px 8px;
}

.etapaItem{
    background-image: linear-gradient(to bottom, rgba(98,211,117,0),rgba(98,211,117,0), rgba(98,211,117,0.07));

}
.etapaItem .cursor{
    cursor: pointer;
}

.etapaItem img{
    border: 2px solid #fff;
    cursor: zoom-in;
    max-width: 60px;
    object-fit: cover;
}

.etapaItem:hover{
    /* background-color: rgb(215, 241, 221); */
    background-image: linear-gradient(to bottom, rgba(215,241,221,0.95),rgba(215,241,221,0.9), rgba(215,241,221,0.5));
    box-shadow: 2px 2px 6px 0px #a7a7a7;
    border-color: green;
}

.etapaItem .active{
    /* background-color: rgb(98, 211, 117); */
    background-image: linear-gradient(to bottom, rgba(98,211,117,0.95),rgba(98,211,117,0.9), rgba(98,211,117,0.5));
    color: #fff
}

.titulo-categoria{
    border-bottom: 5px solid var(--btnbg3);
}

.titulo-categoria h4 {
    padding: 8px 20px;
    color: var(--btntxt3);
    background:  var(--btnbg3);
    margin-bottom: -1px;
    border-top-right-radius: 10px;
    font-family: 'Lobster', cursive;
    text-shadow: -1px 1px 4px black;
}

.header-card{
    color: var(--btntxt3);
    background-color: var(--btnbg3);
    text-shadow: -1px 1px 4px black;
}

.header-card h3{
    color: var(--btntxt3);
    font-family: 'Lobster', cursive;
    text-transform: lowercase !important;
}

.header-card h3:first-letter{
    text-transform: capitalize !important;
}


</style>
